import React, { useMemo } from 'react';
import classnames from 'classnames';
import StringUtil from '@leverege/string-util';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelListEditor } from '@leverege/ui-plugin';
import { Pane, Selector, Label, Text, TabPane, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import LayerRenderer from "./LayerRenderer.js";
import Model from "../../shared/models/MapViewerModel.js";
import S from './MapViewerEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.map.MapViewerEditor');
function MapViewerEditor(props) {
  const {
    value,
    eventData,
    onChange
  } = props;
  const onModelChange = useValueChange(Model, props);
  const mapStyle = value ? Model.getMapStyle(value) : null;
  const STYLES = Model.STYLES;
  const values = useMemo(() => {
    const v = Object.keys(STYLES).map(key => {
      return {
        name: StringUtil.camelCaseToTitleCase(key),
        value: key
      };
    });
    v.push({
      name: 'Custom',
      value: null
    });
    return v;
  }, [STYLES]);
  if (value == null) {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "padding",
      children: t('noModel')
    });
  }
  const isCustom = STYLES[mapStyle] == null;
  const forward = e => {
    onChange({
      value: e.value,
      data: eventData
    });
  };
  return /*#__PURE__*/_jsxs(TabPane, {
    className: S.editor,
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('layers'),
      tabId: "layers",
      children: /*#__PURE__*/_jsx(ModelListEditor, {
        value: value,
        listClassName: S.list,
        selectionHeader: header,
        rendererIsRemovable: false,
        renderer: LayerRenderer,
        model: Model.layers(),
        onChange: forward,
        selectedProps: {
          ...props
        }
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('options'),
      tabId: "options",
      children: /*#__PURE__*/_jsxs("div", {
        className: S.pad,
        children: [/*#__PURE__*/_jsxs("div", {
          className: classnames(S.grid, S.fill),
          children: [/*#__PURE__*/_jsx(Label, {
            children: t('mapStyle')
          }), /*#__PURE__*/_jsx(Selector, {
            eventData: "setMapStyle",
            value: mapStyle,
            values: values,
            nameKey: "name",
            valueKey: "value",
            onChange: onModelChange
          })]
        }), isCustom && /*#__PURE__*/_jsxs("div", {
          className: classnames(S.sub, S.grid, S.fill),
          children: [/*#__PURE__*/_jsx(Label, {
            children: t('customStyle')
          }), /*#__PURE__*/_jsx(TextInput, {
            style: {
              minWidth: '25em'
            },
            hint: t('customStyleHint'),
            eventData: "setCustomMapStyle",
            value: Model.getCustomMapStyle(value),
            onChange: onModelChange
          })]
        })]
      })
    })]
  });
}
function header(item) {
  if (item == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: "subtitle",
    children: item.name || item.layerName
  });
}
export default /*#__PURE__*/React.memo(MapViewerEditor);